export default "__VITE_ASSET__C_rn7zbu__"